<template>
  <div>
    <cdr-text
      class="course-gear-list__header"
      tag="h2"
    >
      {{ showChallenger ? 'What we’ll bring' : 'Gear provided by REI' }}
    </cdr-text>
    <cdr-list
      :modifier="showChallenger ? undefined : 'inline'"
      class="course-gear-list"
    >
      <li
        v-for="provided in gearProvided"
        :key="provided"
        data-ui="rei-gear-list-provided-item"
        class="course-gear-list__item"
      >
        <icon-check-sm />
        <span>{{ provided }}</span>
      </li>
    </cdr-list>
  </div>
</template>

<script>
import { IconCheckSm, CdrText, CdrList } from '@rei/cedar';

export default {
  name: 'GearListComponent',
  components: {
    IconCheckSm,
    CdrText,
    CdrList,
  },
  props: {
    // TODO: Remove property when A/B test ends and target wins
    showChallenger: {
      type: Boolean,
      default: false,
    },
    gearProvided: {
      type: Array,
      required: true,
    },
  },
};
</script>
